import axios from "axios";
import { Text } from "components";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import ExcelJS from "exceljs";
import { saveAs } from "file-saver"; // Install file-saver if you don't have it: npm install file-saver

import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import CustomSelect from "components/SmallComponents/CustomSelect";

function ItemWiseSupplierReport() {
  const [download, setDownload] = useState(false);

  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];
  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(1); // Set to the first day of the current month
  thirtyDaysAgo.setMonth(thirtyDaysAgo.getMonth() - 1); // Go back one month
  // const formattedThirtyDaysAgo = thirtyDaysAgo.toISOString().split('T')[0];
  const firstDayOfCurrentMonth = new Date(
    today.getFullYear(),
    today.getMonth(),
    1
  );
  const formattedThirtyDaysAgo = `${firstDayOfCurrentMonth.getFullYear()}-${String(
    firstDayOfCurrentMonth.getMonth() + 1
  ).padStart(2, "0")}-01`;

  const [timedateflag, setTimeDateFlag] = useState(false);
  const [toDate, setToDate] = useState(formattedToday);
  const [fromDate, setFromDate] = useState(formattedThirtyDaysAgo);
  const [itemDataList, setItemDataList] = useState([]);
  const [dateWiseItemDateList, setDateWiseItemDateList] = useState([]);
  const [mergeddatewiseItemDataList, setMergeddatewiseItemDataList] = useState(
    []
  );
  const [itemId, setItemId] = useState();
  const [taxInvoiceData, setTaxInvoiceData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("grid");
  const [mergedData, setMergedData] = useState([]);
  const [showChart, setShowChart] = useState(false);

  const [supplierList, setSupplierList] = useState([]);
  const [supplierId, setsupplierId] = useState("");
  const [dataToShowInGrid, setDataToShowInGrid] = useState([]);

  //for grid..
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(true); // State for loading indicator
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  //for getting supplier list ....
  useEffect(() => {
    setTimeout(() => {
      getSupplierList();
    }, 1000);
  }, []);

  const getSupplierList = () => {
    axios
      .post(
        "/api/purple-fusion/companypurchaseorderreport/get/supplier",
        {},
        headers
      )
      .then((response) => {
        setSupplierList(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching company purchase items", error);
      });
  };

  // Fetch item data when date range changes
  useEffect(() => {
    setTimeout(() => {
      itemDataGet();
    }, 1500);
  }, [fromDate, toDate, supplierId]);

  const Item_obj = {
    start_date: fromDate,
    end_date: toDate,
    supplier_id: supplierId,
  };

  //getting item data list...
  const itemDataGet = () => {
    axios
      .post(
        "/api/purple-fusion/revenuereport/supplier/get/itemfromcompanypurchaseorder",
        Item_obj,
        {
          ...headers,
          timeout: 20000,
        }
      )
      .then((response) => {
        setItemDataList(response.data);
        // console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Fetch tax invoice data when itemId changes...
  useEffect(() => {
    setTimeout(() => {
      if (selectedOption == "reportView") {
        getCompantPOData();
      }
    }, 500);
  }, [itemId]);

  const obj = {
    start_date: fromDate,
    end_date: toDate,
    item_detail_id: itemId,
  };
  const getCompantPOData = () => {
    axios
      .post(
        "/api/purple-fusion/revenuereport/supplier/get/itemfromcompanypurchaseorder/revenue",
        obj,
        headers
      )
      .then((response) => {
        setTaxInvoiceData(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching company purchase items", error);
      });
  };
  useEffect(() => {
    if (taxInvoiceData.length > 0) {
      toMeargedData(itemId);
    }
  }, [taxInvoiceData]);

  function toMeargedData(id) {
    if (id) {
      const alreadyAdded = mergedData.some(
        (item) => item.item_detail_id === id
      );
      if (alreadyAdded) {
        toast.warn("Item already selected", {
          autoClose: 2000,
        });
      } else {
        const filtered = taxInvoiceData.filter(
          (item) => item.item_detail_id === id
        );
        setMergedData((prevData) => [...prevData, ...filtered]);
      }
    }
  }
  //for excel date wise item revenue generated...
  useEffect(() => {
    setTimeout(() => {
      dateWiseItemDataGet();
    }, 200);
  }, [fromDate, toDate, itemId, supplierId, selectedOption]);

  //getting item data list...and in grid formate
  const dateWiseItemDataGet = () => {
    const obj1 = {
      start_date: fromDate,
      end_date: toDate,
      supplier_id: supplierId,
      item_detail_id: itemId,
    };
    axios
      .post(
        "/api/purple-fusion/revenuereport/supplier/get/item/exceldata",
        obj1,
        {
          ...headers,
          timeout: 20000,
        }
      )
      .then((response) => {
        setDateWiseItemDateList(response.data);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function convertDataToArray(dateWiseItemDateList, uniqueDates) {
    const groupedData = dateWiseItemDateList.reduce((acc, curr) => {
      if (!acc[curr.item_name]) {
        acc[curr.item_name] = {
          item_name: curr.item_name,
          code: curr.code,
          code_op: curr.code_op,
          taxes: {},
          total_qty: 0,
          total_amount: 0,
        };
      }
      // If the date already exists, accumulate the quantity and amount, otherwise, initialize it
      if (acc[curr.item_name].taxes[curr.createdon]) {
        acc[curr.item_name].taxes[curr.createdon].quantity += curr.quantity;
        acc[curr.item_name].taxes[curr.createdon].amount += curr.total_amount;
      } else {
        acc[curr.item_name].taxes[curr.createdon] = {
          quantity: curr.quantity,
          amount: curr.total_amount,
        };
      }
      // Accumulate total quantity and total amount for each item
      acc[curr.item_name].total_qty += curr.quantity;
      acc[curr.item_name].total_amount += curr.total_amount;
      return acc;
    }, {});

    // Check if uniqueDates exists and is an array
    if (!Array.isArray(uniqueDates)) {
      return [];
    }

    // Prepare the result array
    const resultArray = [];
    for (const itemName in groupedData) {
      if (!groupedData.hasOwnProperty(itemName)) continue;
      const row = {
        item_name: groupedData[itemName].item_name,
        code: groupedData[itemName].code, // Include `code`
        code_op: groupedData[itemName].code_op, // Include `code_op`
      };
      let total_qty = 0;
      let total_amount = 0;
      uniqueDates.forEach((date) => {
        const entry = groupedData[itemName].taxes[date] || {
          quantity: 0,
          amount: 0,
        };
        const amount = Number(entry.amount || 0);
        row[date] = `${entry.quantity} / ${amount.toFixed(2)}`;
        total_qty += entry.quantity;
        total_amount += amount;
      });
      row.total_qty = total_qty;
      row.total_amount = total_amount.toFixed(2);
      resultArray.push(row);
    }
    return resultArray;
  }
  useEffect(() => {
    if (dateWiseItemDateList && dateWiseItemDateList.length > 0) {
      const uniqueDates = [
        ...new Set(dateWiseItemDateList.map((item) => item.createdon)),
      ].sort();

      if (uniqueDates.length > 0) {
        const transformedData = convertDataToArray(
          dateWiseItemDateList,
          uniqueDates
        );
        setRowData(transformedData);

        const columns = [
          { headerName: "Item Name", field: "item_name", filter: true },
          { headerName: "Item Code", field: "code", filter: true }, // Item code column
          { headerName: "Provided Code", field: "code_op", filter: true }, // Provided code column
          {
            headerName: "Total QTY",
            field: "total_qty",
            width: 110,
            filter: true,
          },
          {
            headerName: "Basic Amount",
            field: "total_amount",
            width: 110,
            filter: true,
          },
          ...uniqueDates.map((date) => ({
            headerName: date,
            field: date,
            width: 150,
            cellRenderer: (params) => params.value,
          })),
        ];

        setColumnDefs(columns);
      }
    }
  }, [dateWiseItemDateList]);

  //item search by code and code_op item

  const filterOptions = (candidate, input) => {
    // Filter options based on label, value, code, and code_op
    return (
      candidate.label?.toLowerCase().includes(input?.toLowerCase()) ||
      candidate.data.code?.toLowerCase().includes(input?.toLowerCase()) ||
      candidate.data.code_op?.toLowerCase().includes(input?.toLowerCase())
    );
  };

  const formatOptionLabel = ({ label, code, code_op }) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        // justifyContent: "space-between", // Ensures proper spacing
        width: "100%", // Adjust width of the parent container
      }}
    >
      <div style={{ flex: 2, textAlign: "left" }}>{label}</div>
      {code_op && (
        <div style={{ flex: 1, marginLeft: 20, textAlign: "center" }}>
          {code_op}
        </div>
      )}
      {code && (
        <div style={{ flex: 1, marginLeft: 20, textAlign: "center" }}>
          {code}
        </div>
      )}
    </div>
  );

  //for grid ...
  useEffect(() => {
    if (dateWiseItemDateList) {
      const newArray = convertDataToArray(dateWiseItemDateList);
      setDataToShowInGrid(newArray); // Update the state with the new data
      setLoading(false);
    }
  }, [dateWiseItemDateList]);

  //for dateWiseItemDateList mearge for excel report...
  useEffect(() => {
    if (dateWiseItemDateList.length > 0) {
      toMeargedDataForExcel(itemId);
    }
  }, [dateWiseItemDateList]);

  function toMeargedDataForExcel(id) {
    if (id) {
      const alreadyAdded = mergeddatewiseItemDataList.some(
        (item) => item.item_detail_id === id
      );
      if (alreadyAdded) {
      } else {
        const filtered = dateWiseItemDateList.filter(
          (item) => item.item_detail_id === id
        );
        setMergeddatewiseItemDataList((prevData) => [...prevData, ...filtered]);
      }
    }
  }
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "white",
            padding: "5px",
            border: "1px solid #ccc",
          }}
        >
          <p>{`Name: ${payload[0].payload.item_name}`}</p>
          <p>{`Total Quantity: ${Number(payload[0].value).toFixed(2)}`}</p>
        </div>
      );
    }
    return null;
  };

  // for option change...
  const handleOptionChange = (event) => {
    const selectedValue = event.target.value; // Access event.target safely
    setSelectedOption(selectedValue); // Update selected option

    // Set conditional logic for showing chart
    if (selectedValue === "grid") {
      setShowChart(false);
      setItemId("");
      setMergedData([]); // Set to false if 'grid' is selected
    } else {
      setShowChart(true);
      setMergedData([]); // You may want to add this case for other views
    }
  };

  const DownloadExcel = (excelType) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Item-wise Purchase Report");

    const formatDate = (date) => {
      if (typeof date === "string") {
        const [day, month, year] = date.split("/").map(Number);
        const parsedDate = new Date(year, month - 1, day);
        if (isNaN(parsedDate.getTime())) {
          console.log(`Invalid date: ${date}`);
          return "";
        }
        const dayStr = parsedDate.getDate().toString().padStart(2, "0");
        const monthStr = (parsedDate.getMonth() + 1)
          .toString()
          .padStart(2, "0");
        const yearStr = parsedDate.getFullYear();
        return `${dayStr}/${monthStr}/${yearStr}`;
      } else if (date instanceof Date && !isNaN(date.getTime())) {
        const dayStr = date.getDate().toString().padStart(2, "0");
        const monthStr = (date.getMonth() + 1).toString().padStart(2, "0");
        const yearStr = date.getFullYear();
        return `${dayStr}/${monthStr}/${yearStr}`;
      }
      console.log(`Invalid date type: ${date}`);
      return "";
    };

    const dataList = showChart
      ? mergeddatewiseItemDataList
      : dateWiseItemDateList;

    const uniqueItemList = Array.from(
      new Set(dataList.map((data) => data.item_name))
    );
    // const uniqueDates = Array.from(new Set(dataList.map(data => new Date(data.createdon).toLocaleDateString())));

    const uniqueDates = Array.from(
      new Set(
        dataList.map((data) => new Date(data.createdon).toLocaleDateString())
      )
    ).sort((a, b) => new Date(a) - new Date(b)); // Sort dates in ascending order

    const formatHeadersDate = (dateStr) => {
      const [year, month, day] = dateStr.split("-");
      return `${day}-${month}-${year}`;
    };

    worksheet.addRow([
      "Report Name:",
      `Item-wise Sales Report for ${
        excelType === "quantity" ? "Quantity" : "Basic Amount"
      }`,
    ]);
    worksheet.addRow(["From Date:", formatHeadersDate(fromDate)]);
    worksheet.addRow(["To Date:", formatHeadersDate(toDate)]);
    worksheet.addRow([]);

    // Updated Headers
    const headers = [
      "SR.NO",
      "Item Name",
      "Item Code",
      "Provided Item Code",
      ...uniqueDates.map((date) => formatDate(date)),
      "Total",
    ];
    worksheet.addRow(headers);
    worksheet.views = [{ state: "frozen", ySplit: 5 }];

    // Styling for first three rows
    for (let i = 1; i <= 3; i++) {
      const cell = worksheet.getCell(i, 1);
      cell.font = { bold: true };
    }

    // Styling for the first five rows
    for (let i = 1; i <= 4; i++) {
      for (let j = 1; j <= headers.length; j++) {
        const cell = worksheet.getRow(i).getCell(j);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFFFF" },
        };
      }
    }

    worksheet.getRow(5).eachCell({ includeEmpty: true }, (cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF368BC1" },
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    uniqueItemList.forEach((itemName, itemIndex) => {
      const row = [itemIndex + 1, itemName];

      // Add 'code' and 'code_op' for each item
      const itemData = dataList.find((data) => data.item_name === itemName);
      const itemCode = itemData ? itemData.code : "";
      const itemCodeOp = itemData ? itemData.code_op : "";

      row.push(itemCode, itemCodeOp);

      let totalAmountForRow = 0;

      uniqueDates.forEach((date) => {
        const totalValue = dataList
          .filter(
            (data) =>
              data.item_name === itemName &&
              new Date(data.createdon).toLocaleDateString() === date
          )
          .reduce(
            (acc, data) =>
              acc +
              Number(
                excelType === "quantity" ? data.quantity : data.total_amount
              ),
            0
          );

        const roundedTotal = Math.round(totalValue * 100) / 100;
        totalAmountForRow += roundedTotal;
        row.push(roundedTotal);
      });

      row.push(Math.round(totalAmountForRow * 100) / 100);
      worksheet.addRow(row);
    });

    worksheet.getColumn(1).alignment = { horizontal: "left" };
    worksheet.getColumn(2).alignment = { horizontal: "left" };

    for (let i = 3; i <= worksheet.columns.length; i++) {
      worksheet.getColumn(i).alignment = { horizontal: "right" };
    }

    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(
        new Blob([buffer]),
        `Item-wise Purchase Report ${excelType} ${new Date()
          .toISOString()
          .slice(0, 10)}.xlsx`
      );
    });
  };

  //fo excel download title..(timeStapm)
  const [dateTime, setDateTime] = useState("");
  useEffect(() => {
    const currentTimestamp = new Date();
    const formattedDate = currentTimestamp
      .toLocaleDateString([], {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .replace(/\//g, "-");
    const formattedDateTime = `${formattedDate}`;
    setDateTime(formattedDateTime);
  }, [timedateflag]);

  //for reset the select box when form date and to date change...
  const [resetCodeKey, setResetCodeKey] = useState(0);
  useEffect(() => {
    setResetCodeKey((prevKey) => prevKey + 1);
  }, [fromDate, toDate, supplierId, selectedOption]);

  //to remove cards...
  const handleRemove = (item_name) => {
    const updatedData = mergedData.filter(
      (item) => item.item_name !== item_name
    );
    setMergedData(updatedData);
    const updateMergeddatewiseItemDataList = mergeddatewiseItemDataList.filter(
      (item) => item.item_name !== item_name
    );
    setMergeddatewiseItemDataList(updateMergeddatewiseItemDataList);
  };

  // Validate "To" date when it changes
  const validateToDate = (newToDate) => {
    if (fromDate) {
      const from = new Date(fromDate);
      const maxToDate = new Date(from.setDate(from.getDate() + 366))
        .toISOString()
        .split("T")[0];

      if (newToDate > maxToDate) {
        toast.error(
          'The "To" date must be within 366 days after the "From" date.'
        );
        setToDate(maxToDate); // Reset to maximum allowed date
      } else {
        setToDate(newToDate);
      }
    }
  };
  //for consider max value in graph
  const maxValue = Math.max(...mergedData.map((data) => data.quantity));
  return (
    <>
      <ToastContainer />
      <div className="w-full flex flex-col">
        <div className="flex justify-between items-start mt-3 mx-3 gap-1 mb-5">
          <div className="flex flex-row items-center w-full">
            <Text className="text-sm md:text-[22px] text-gray-600  sm:text-xl pt-2 mr-2 ml-2 mb-2 ">
              From
            </Text>
            <input
              name="from_date"
              type="date"
              value={fromDate}
              onChange={(e) => {
                setFromDate(e.target.value);
                validateToDate(toDate); // Validate "To" date whenever "From" date changes
              }}
              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] pt-4"
            />
            <Text className="text-sm md:text-[22px] text-gray-600 sm:text-xl pt-2 mr-2 ml-2 mb-2">
              To
            </Text>

            <input
              name="to_date"
              type="date"
              value={toDate}
              onChange={(e) => {
                // setToDate(e.target.value);
                validateToDate(e.target.value);
              }}
              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] pt-4"
            />
            {/* for customer dropdown.. */}
            <CustomSelect
              options={[
                { label: "All Supplier", value: "" }, // Add this option
                ...supplierList.map((item) => ({
                  label: item.name,
                  value: item.id,
                })),
              ]}
              className="bg-white-A700 border border-gray-200_02 border-solid h-9 ml-2 rounded-md w-[18%]"
              onChange={(selectedOption) => {
                setsupplierId(selectedOption.value);
              }}
              placeholder="All Supplier"
            />

            {/* for item dropdown */}
            <Select
              options={
                selectedOption === "reportView"
                  ? itemDataList.map((item) => ({
                      label: item.item_name,
                      value: item.item_detail_id,
                      code: item.code,
                      code_op: item.code_op,
                    }))
                  : [
                      { label: "All Items", value: "" }, // Option for reportView
                      ...itemDataList.map((item) => ({
                        label: item.item_name,
                        value: item.item_detail_id,
                        code: item.code,
                        code_op: item.code_op,
                      })),
                    ]
              }
              className="bg-white-A700 border border-gray-200_02 border-solid h-9 ml-2 rounded-md w-[18%]"
              onChange={(selectedOption1) => {
                if (selectedOption == "grid") {
                  setMergedData([]);
                }
                setItemId(selectedOption1.value);
                setShowChart(false);
              }}
              filterOption={filterOptions}
              formatOptionLabel={formatOptionLabel}
              placeholder="Search Item by Name ,Codes"
              key={resetCodeKey}
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "35px", // Adjust control height
                  height: "35px", // Adjust control height
                  fontSize: "14px", // Adjust font size
                  width: "400px", // Adjust control width
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  height: "35px",
                }),
                valueContainer: (base) => ({
                  ...base,
                  height: "35px",
                  padding: "0 8px",
                }),
                menu: (provided) => ({
                  ...provided,
                  width: "100%", // Ensures the dropdown menu is full width
                  backgroundColor: "#fff", // Ensures a solid background
                  zIndex: 1000, // Ensures it appears above other elements
                }),
              }}
            />
            <div className="flex items-center justify-start gap-1 sm:flex-col">
              <label className="mr-2 text-sm whitespace-nowrap ml-4">
                <input
                  id="grid"
                  type="radio"
                  value="grid"
                  checked={selectedOption === "grid"}
                  onChange={(event) => handleOptionChange(event)} // Ensure event is passed
                  className="mr-1"
                />
                Grid
              </label>
              <label className="text-sm whitespace-nowrap">
                <input
                  id="reportView"
                  type="radio"
                  value="reportView"
                  checked={selectedOption === "reportView"}
                  onChange={(event) => handleOptionChange(event)} // Ensure event is passed
                  className="mr-1"
                />
                Bar Chart
              </label>
            </div>
          </div>
          <div className="flex items-center">
            <div
              className="flex flex-col relative z-20 "
              onMouseEnter={() => setDownload(true)}
              onMouseLeave={() => setDownload(false)}
            >
              {
                <button
                  id="dropdownDefaultButton"
                  data-dropdown-toggle="dropdown"
                  className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 w-28 mr-4 "
                  type="button"
                >
                  {"Download"} &nbsp;{" "}
                  <svg
                    class="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>
              }
              <div
                className={`${
                  download ? "absolute top-[32px]" : "hidden"
                } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[125px] bg-white-A700  dark:bg-gray-700`}
              >
                <ul
                  class="py-0 text-sm text-gray-700 dark:text-gray-200"
                  aria-labelledby="dropdownDefaultButton"
                >
                  <li>
                    <a
                      className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      onClick={() => DownloadExcel("quantity")}
                    >
                      Excel for Quantity
                    </a>
                  </li>
                  <li>
                    <a
                      className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      onClick={() => DownloadExcel("total_amount")}
                    >
                      Excel for Total Amount
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {selectedOption == "grid" && dateWiseItemDateList.length != 0 && (
          <div>
            <div
              className="ag-theme-quartz"
              style={{ height: 400, width: "100%" }}
            >
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                pagination={true}
                rowHeight={40}
                overlayLoadingTemplate={loading ? "Loading..." : null}
                overlayNoRowsTemplate={
                  loading
                    ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
                    : "No Record Found"
                }
              />
            </div>
          </div>
        )}

        {!showChart && mergedData.length !== 0 && selectedOption != "grid" && (
          <div className="mt-3 w-full flex flex-wrap justify-center gap-4">
            {mergedData.map((item) => (
              <div
                key={item.id}
                className="bg-white border border-gray-200 rounded-lg shadow-xl p-4 w-[200px] h-[100px] flex flex-col justify-between relative"
              >
                {/* Cross button */}
                <button
                  className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
                  onClick={() => handleRemove(item.item_name)} // Assuming you have a function to handle removal
                >
                  &times;
                </button>

                <div className="text-gray-800 text-sm font-semibold truncate">
                  {item.item_name}
                </div>
                <div className="text-gray-600 text-sm">
                  Total Quantity: {item.quantity}
                </div>
              </div>
            ))}
          </div>
        )}

        {mergedData.length > 0 && !showChart && selectedOption != "grid" && (
          <div className="flex justify-center mt-3">
            <button
              type="button"
              className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700"
              onClick={() => setShowChart(true)}
            >
              Generate Report
            </button>
          </div>
        )}

        {/* for card to say please select items */}
        {selectedOption == "reportView" && mergedData.length == 0 && (
          <div className="w-[96%] h-full flex justify-center items-center m-4 p-6 border-2 mt-20 shadow-xl rounded-md bg-gray-100">
            <div className="text-center">
              <h2 className="text-lg font-bold text-gray-700">
                First Select an Item
              </h2>
              <p className="text-gray-500 mt-2">
                Please select an item and generate the report to view the chart.
              </p>
            </div>
          </div>
        )}

        {/* For Bar Chart */}
        {showChart &&
          selectedOption === "reportView" &&
          mergedData.length > 0 && (
            <div className="w-[96%] h-full flex-col m-4 p-4 overflow-scroll border-2 shadow-xl">
              <ResponsiveContainer width="100%" height={350}>
                <BarChart
                  layout="vertical"
                  data={mergedData}
                  margin={{
                    top: 50,
                    right: 20,
                    left: -20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <Legend
                    verticalAlign="bottom"
                    wrapperStyle={{ fontSize: "10px" }}
                  />
                  <ReferenceLine x={0} stroke="#000" />
                  <XAxis
                    type="number"
                    tickFormatter={(value) => {
                      if (value >= 1000000) {
                        return `${(value / 1000000).toFixed(1)}M`;
                      } else if (value >= 100000) {
                        return `${(value / 100000).toFixed(1)}L`;
                      } else if (value >= 1000) {
                        return `${(value / 1000).toFixed(1)}K`;
                      } else {
                        return value.toFixed(0);
                      }
                    }}
                    tick={{ fontSize: "10px" }}
                    label={{
                      style: { fontSize: "12px" }, // Set font size for the label
                    }}
                    domain={[0, maxValue * 1.1]} // Set domain to fit data with some padding (10%)
                  />
                  <YAxis
                    type="category"
                    dataKey="item_name"
                    tick={{
                      fontSize: "10px",
                      textAnchor: "middle",
                      angle: 0,
                      dy: 0,
                      dx: -150,
                    }}
                    tickFormatter={(name) => name.slice(0, 100)} // Shorten item names to fit better
                    width={350}
                  />
                  <Tooltip
                    content={<CustomTooltip />}
                    wrapperStyle={{ fontSize: "10px" }}
                  />
                  <Bar
                    dataKey="quantity"
                    name="Quantity"
                    fill="#82ca9d"
                    activeBar={{ fill: "#008080", stroke: "purple" }}
                    barSize={40}
                  >
                    <LabelList
                      dataKey="quantity"
                      position="right"
                      formatter={(value) => Number(value).toFixed(2)}
                      style={{ fontSize: "12px" }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          )}
      </div>
    </>
  );
}

export default ItemWiseSupplierReport;
